import React from 'react';

import sharedStyles from '../../sharedStyles.module.css';
import styles from './unpublished-survey.module.css';
interface UnpublishedSurveyProps {
    title: string;
    message: string;
}

const UnpublishedSurvey: React.FC<UnpublishedSurveyProps> = ({ title, message }) => {
    return (
        <div
            className={`${sharedStyles.boxContainer} ${styles.container}`}
            data-testid="unpublished-survey-notice"
        >
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.message}>{message}</p>
        </div>
    );
};

export default UnpublishedSurvey;
